import React, { useState } from "react";
import { fetchProjects, deleteProject } from "./SkeyecubeProjectsAPI";
import SkeyecubeProjectsTable from "./SkeyecubeProjectsTable";
import SkeyecubeAddProjectDialog from "./SkeyecubeAddProjectDialog";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import { extractMsg } from "../../../utils/errorUtils";
import skeyecubeProjectsHelp from "../../../content/help/skeyecube-projects.json";

export default function SkeyecubeProjects({
  pageTitle = "Skeyecube Projects",
}) {
  usePageTitle("SkeyeCube Projects - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchProjects,
    filterFields: ["name", "owner", (p) => p.num_cubes?.toString()],
  });
  const isRoleUser = useIsRoleUser();

  const [addModalOpen, setAddModalOpen] = useState(false);

  const handleDeleteProject = async (projectName) => {
    try {
      await deleteProject(projectName);
      messageApi.success(`Project "${projectName}" deleted successfully.`);
      loadData();
    } catch (error) {
      messageApi.error(extractMsg(error, `Failed to delete "${projectName}"`));
    }
  };

  return (
    <PageLayout
      title={pageTitle}
      logo="/img/majesteye-icon-skeye-cube-square-white-background-no-label"
      description="Manager for Skeyecube projects, allowing you to create, and organize your projects in one place."
      helpContent={skeyecubeProjectsHelp}
    >
      {contextHolder}
      <SearchToolbar
        search={searchText}
        onSearchChange={handleSearch}
        onClearFilter={clearFilter}
        showAdd={!isRoleUser}
        addButtonLabel="Add Project"
        onAdd={() => setAddModalOpen(true)}
      />
      <SkeyecubeProjectsTable
        data={filteredData}
        loading={loading}
        page={page}
        isRoleUser={isRoleUser}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onDeleteProject={handleDeleteProject}
      />
      <SkeyecubeAddProjectDialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
    </PageLayout>
  );
}
